'use strict';

var angular = require('angular');
var MarketWizardController = function MarketWizardController($scope, $rootScope, validationService, FeatureToggleService) {
  $scope.isBreakConnectionsEnabled = FeatureToggleService.isEnabled('BREAK_CONNECTIONS');
  $scope.isPosFeatureDisabled = FeatureToggleService.isDisabled('SPOS');
  $scope.isSMLFeatureDisabled = FeatureToggleService.isDisabled('SML');
  $scope.isMarketControlTypeChanged = FeatureToggleService.isEnabled('MARKET_CONTROL_TYPE') ? 'Entities and Control Type' : 'Entities';
  $scope.validateStepSponsorship = function () {
    return validationService.validateStepSponsorship();
  };
  $scope.validateStepMarketShare = function () {
    return validationService.validateStepMarketShare();
  };
  $scope.$on('wizard:stepChanged', function (event, stepEntered) {
    $scope.$broadcast('scheduleChange:stepEntered', stepEntered.step.title);
  });
  $scope.$watch('scheduleChange.significantManagedEntities', function () {
    var significantEntities = $scope.scheduleChange && $scope.scheduleChange.significantManagedEntities;
    $scope.noSignificantMarkets = significantEntities && significantEntities.length === 0;
  });
  $scope.finishedWizard = angular.noop;
};
MarketWizardController.$inject = ['$scope', '$rootScope', 'ValidationService', 'FeatureToggleService'];
module.exports = MarketWizardController;